import { Add as AddIcon, ArrowBack, CreateNewFolder, Delete, MoveUp } from "@mui/icons-material";
import { useStore } from "@priolo/jon";
import ButtonCmp, { BTT_SHAPE } from "components/controls/buttons/ButtonCmp";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import cropRecipeSo from "stores/library/cropRecipe";



const CropsRecipesTableFooter: FunctionComponent = () => {

	// STORE
	const cropRecipeSa = useStore(cropRecipeSo)


	// HOOKs
	const { t } = useTranslation()

	// HANDLERs
	const handleNewFolder = () => cropRecipeSo.openFolderInEdit(null)
	const handleMoveFolder = () => cropRecipeSo.setFolderSelectorOpen(true)
	const handleDeselect = () => cropRecipeSo.setSelectedIds([])
	const handleMoveInNewFolder = () => cropRecipeSo.openFolderInEdit(null)
	const handleBulkArchive = () => cropRecipeSo.bulkArchive()

	// RENDER
	const haveSelected = cropRecipeSa.selectedIds?.length > 0
	const haveNoArchived = cropRecipeSa.selectedIds.some(id => !cropRecipeSo.getById(id)?.archived)

	return haveSelected ? <>

		<ButtonCmp sx={{ ml: "26px", mr: "20px" }}
			shape={BTT_SHAPE.MAIN}
			startIcon={<ArrowBack />}
			onClick={handleDeselect}
		>DESELECT</ButtonCmp>

		<ButtonCmp sx={{ mr: "20px" }}
			startIcon={<MoveUp />}
			onClick={handleMoveFolder}
		>MOVE</ButtonCmp>

		<ButtonCmp sx={{ mr: "20px" }}
			startIcon={<CreateNewFolder />}
			onClick={handleMoveInNewFolder}
		>IN NEW FOLDER</ButtonCmp>

		{haveNoArchived && (
			<ButtonCmp sx={{ mr: "20px" }}
				startIcon={<Delete color="secondary" />}
				onClick={handleBulkArchive}
			>ARCHIVE ALL</ButtonCmp>
		)}


	</> : <>

		<ButtonCmp sx={{ ml: "26px", mr: "20px" }}
			shape={BTT_SHAPE.MAIN}
			startIcon={<CreateNewFolder />}
			onClick={handleNewFolder}
		>NEW FOLDER</ButtonCmp>

		<ButtonCmp sx={{ mr: "20px" }}
			shape={BTT_SHAPE.MAIN}
			href="/crops_recipes/new"
			startIcon={<AddIcon />}
		>{t("footer.crops-recipes.new")}</ButtonCmp>

	</>
}

export default CropsRecipesTableFooter